module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/logo-xbox.81c832c5.svg";